import { styled, type GDSStyleObject } from "@leagueplatform/genesis-core";
import LOGO from "assets/emblem-health-logo.svg";
import { APP_NAME } from "common/constants";

type LogoProps = {
  width: GDSStyleObject["width"];
  css?: GDSStyleObject;
};

const StyledImage = styled("img");

export const Logo = ({ width, css }: LogoProps) => (
  <StyledImage
    alt={APP_NAME}
    src={LOGO}
    css={{
      width,
      maxWidth: "100%",
      ...css,
    }}
  />
);
